module.exports = __webpack_public_path__ + "media/team/YuYi-Thumbnail-e3a09afb.png";